import { TMetricQueryParams } from 'types/GlobalMetric'
import { CustomPeriodFilter, PeriodFilter } from 'types/GlobalWidget'

import { parsePeriodFilter } from 'utils/periodFilter'

/**
 * Returns true when any query param other than the default period_filter is
 * set, matching the chip-display logic used by MetricActiveFilters.
 * Works with both raw URL params (period_filter undefined when default) and
 * effective state params (period_filter always set).
 */
export function hasActiveMetricQueryParams(
  queryParams: TMetricQueryParams
): boolean {
  return (
    !!queryParams.filter ||
    !!queryParams.from_date ||
    (!!queryParams.period_filter &&
      queryParams.period_filter !== PeriodFilter.LAST_12_MONTHS_TO_TODAY) ||
    !!queryParams.segment_by
  )
}

/**
 * Produces the updated TMetricQueryParams after a period selection change.
 * Handles both custom date-range objects and named PeriodFilter values.
 */
export function applyPeriodToQueryParams(
  queryParams: TMetricQueryParams,
  period: PeriodFilter | CustomPeriodFilter | null
): TMetricQueryParams {
  const periodQueryParams = parsePeriodFilter(period)

  if (periodQueryParams) {
    return {
      ...queryParams,
      ...periodQueryParams
    }
  }

  return queryParams
}
